import React, { useState, useEffect } from "react";
import { Table, Spin, Alert } from "antd";
import { getRequest } from "../../../service";
import { getEmployeeData } from "../../../utils/localStorage";
import { formatDate } from "../../../utils/dateTime";

const Assets = ({ employeeId }) => {
  const [assetsData, setAssetsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const employeeData = getEmployeeData();

  const columns = [
    {
      title: "Asset Code",
      dataIndex: "assetCode",
      key: "assetCode",
      responsive: ["xs"],
    },
    {
      title: "Asset Name",
      dataIndex: "assetName",
      key: "assetName",
      responsive: ["sm"],
    },
    {
      title: "Serial Number",
      dataIndex: "serialNumber",
      key: "serialNumber",
      responsive: ["md"],
    },
    {
      title: "Asset Price",
      dataIndex: "assetPrice",
      key: "assetPrice",
      responsive: ["lg"],
      render: (price) => price ? `${employeeData.currency} ${parseFloat(price).toLocaleString()}` : '-'
    },
    {
      title: "Assign Date",
      dataIndex: "assignDate",
      key: "assignDate",
      responsive: ["xl"],
      render: (date) => date ? formatDate(date) : '-'
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      responsive: ["xxl"],
    }
  ];

  useEffect(() => {
    const fetchAssets = async () => {
      if (!employeeId) return;
      
      setLoading(true);
      setError(null);
      
      try {
        const response = await getRequest(`/api/assets?employeeId=${employeeId}`);
        
        if (response && Array.isArray(response)) {
          // Transform the API response to match table structure
          const transformedData = response.flatMap(assetRecord => 
            assetRecord.assetDetails.map((asset, index) => ({
              key: `${assetRecord._id}-${asset.id || index}`,
              assetCode: asset.inventoryId || asset.id || 'N/A',
              assetName: asset.productName,
              serialNumber: asset.serialNumber,
              assetPrice: asset.price,
              assignDate: asset.assignDate,
              description: asset.description
            }))
          );
          
          setAssetsData(transformedData);
        }
      } catch (err) {
        setError(err.message || "Failed to fetch assets data");
        console.error("Error fetching assets:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAssets();
  }, [employeeId]);

  if (loading) {
    return (
      <div className="w-full rounded-lg border-t-[#231564] border-2 border-form-bg px-3 py-3 bg-white text-md flex justify-center items-center h-32">
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full rounded-lg border-t-[#231564] border-2 border-form-bg px-3 py-3 bg-white text-md">
        <Alert message="Error" description={error} type="error" showIcon />
      </div>
    );
  }

  return (
    <div className="w-full rounded-lg border-t-[#231564] border-2 border-form-bg px-3 py-3 bg-white text-md">
      <Table 
        columns={columns} 
        dataSource={assetsData}
        pagination={false}
        locale={{ emptyText: "No assets found" }}
        scroll={{ x: true }}
      />
    </div>
  );
};

export default Assets;